(() => {
const nav=document.querySelector('[data-ae-breadcrumbs]');
if(!nav)return;
const tree=JSON.parse(document.getElementById('ae-navigation-tree').textContent);
const original=nav.innerHTML, hidden=nav.hidden;
const home=nav.querySelector('a');
const homeUrl=home.href,homeTitle=home.textContent;
function update(){
 const key=document.documentElement.dataset.aeReview;
 if(!key){nav.innerHTML=original;nav.hidden=hidden;return;}
 const matches=url=>{const parsed=new URL(url,location.origin);if(parsed.searchParams.get('ae_review')===key)return true;const slug=parsed.pathname.split('/').filter(Boolean).pop();return slug===key || (key==='hub' && slug==='kendini-farkli-yollarla-kesfet') || (key==='collections' && slug==='koleksiyonlar');};
 let path=[];
 for(const parent of tree){if(matches(parent.url)){path=[parent];break;}const child=parent.children.find(c=>matches(c.url));if(child){path=[parent,child];break;}}
 if(!path.length){nav.hidden=true;return;}
 const ol=document.createElement('ol');
 for(const [i,item] of [{title:homeTitle,url:homeUrl},...path].entries()){
 const li=document.createElement('li');
 if(i===path.length){li.textContent=item.title;li.setAttribute('aria-current','page');}
 else{const a=document.createElement('a');a.href=item.url;a.textContent=item.title;li.append(a);}
 ol.append(li);
 }
 nav.replaceChildren(ol);nav.hidden=false;
}
new MutationObserver(update).observe(document.documentElement,{attributes:true,attributeFilter:['data-ae-review']});
update();
})();
